import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';

const {
  APPROVE_RECHECK_DISCHARGE_REQUEST,
  APPROVE_RECHECK_DISCHARGE_SUCCESS,
  APPROVE_RECHECK_DISCHARGE_FAILURE,
  APPROVE_RECHECK_DISCHARGE_LOADING,
} = documentationActions;

function* approveRecheckDischarge(action: any): SagaReturnType<any> {
  try {
    yield put({ type: APPROVE_RECHECK_DISCHARGE_LOADING });
    const response = yield call(templateService.approveRecheckDischarge, action.payload);
    if (response?.status === 200) {
      yield put({ type: APPROVE_RECHECK_DISCHARGE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: APPROVE_RECHECK_DISCHARGE_FAILURE, payload: error });
  }
}

function* approveRecheckDischargeSaga() {
  yield takeEvery(APPROVE_RECHECK_DISCHARGE_REQUEST, approveRecheckDischarge);
}

export default approveRecheckDischargeSaga;
